<template>
  <div>
    <CModal
      centered
      :show.sync="showModal"
      :draggable="false"
      :showFooter="false"
    >
      <CRow class="mt-2">
        <CCol col="12" class="ml-4">
          {{ $t('The user cannot be deleted because it is the contact of a member.') }}
        </CCol>
      </CRow>
    </CModal>
    <CCard>
      <CCardHeader>
        {{ $t("Users") }}
        <div class="card-header-actions">
          <CButton
            class="mz-button v2-mz-btn mr-2"
            color="primary"
            @click="
              $downloadFile({
                url: USER_ENDPOINTS.export,
              })
            "
          >
            {{ $t("Export") }}
            <i class="ml-2 mz-icon icon-download-alt color-inherit" />
          </CButton>
          <AddButton
            :to="{
              name: 'User',
              params: { id: 'new' },
            }"
          />
        </div>
      </CCardHeader>

      <CCardBody>
        <table-component
          :columns="['firstname', 'lastname', 'email', 'role', 'actions']"
          :headings="tableHeadings"
          :url="USER_ENDPOINTS.list"
          :filter-exclude-columns="['actions']"
          :table-override-filters="tableOverrideFilters"
          ref="table"
          v-if="roles.length"
        >
          <template slot="firstname" slot-scope="{ row }">
            {{ row.firstname || "" }}
          </template>
          <template slot="lastname" slot-scope="{ row }">
            {{ row.lastname || "" }}
          </template>
          <template slot="email" slot-scope="{ row }">
            <CLink :to="{ name: 'User', params: { id: row.id } }">
              {{ row.email }}
            </CLink>
          </template>
          <template slot="actions" slot-scope="{ row }">
            <CButton
              @click="() => deleteUser(row)"
              color="danger"
              variant="outline"
            >
              <i class="fa fa-trash-o" />
            </CButton>
          </template>
        </table-component>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { USER_ENDPOINTS, users } from "@/services/users";
import AddButton from "@/components/AddButton";

export default {
  name: "users",
  components: { AddButton },
  data() {
    return {
      USER_ENDPOINTS,
      roles: [],
      showModal: false
    };
  },
  mounted() {
    this.fetchRoles();
  },
  computed: {
    tableHeadings() {
      return {
        firstname: this.$t("Name"),
        lastname: this.$t("Last Name"),
        email: "E-mail",
        role: this.$t("Role"),
        actions: "",
      };
    },
    tableOverrideFilters() {
      return {
        role: {
          options: this.roles,
        },
      };
    },
  },
  methods: {
    async fetchRoles() {
      this.roles = await users.getRoles();
    },
    async deleteUser(user) {
      if (!user?.members?.length) {
        this.showModal = true
        return
      }
      if (!(await confirm(`Are you sure you want to delete user ${user.email}?`))) {
        return;
      }
      try {
        await users.deleteUser(user.id);
      } catch (e) {}
      this.$refs.table.$refs.table.getData();
    },
  },
};
</script>

<style>
.modal-header {
  color: #fff;
  background-color: #23145f;
  border-color: #23145f;
}
</style>
